(function(app) {

    app.provider("caseApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {
                            getCase: function(caseId) {
                                return crmApiGateway.get(`/Cases/${caseId}`);
                            },
                            getCases: function() {
                                return crmApiGateway.getArray("/Cases");
                            },
                            getClientCases: function(clientId) {
                                return crmApiGateway.getArray(`/Clients/${clientId}/Cases`);
                            },
                            getClientCaseAndAccountList: function(clientId) {
                                return crmApiGateway.getArray(`/Clients/${clientId}/CaseAndAccountList`);
                            },
                            getPlanningNotes: function(caseId) {
                                return crmApiGateway.getArray(`/Cases/${caseId}/PlanningNotes`);
                            },
                            getAccounts: function(caseId) {
                                return crmApiGateway.get(`/Cases/${caseId}/Accounts`);
                            },
                            updateCase: function(caseId, clientCase) {
                                return crmApiGateway.put(`/Cases/${caseId}`, clientCase);
                            },
                            updatePlanningNote: function(caseId, noteId, note) {
                                return crmApiGateway.put(`/Cases/${caseId}/PlanningNotes/${noteId}`, note);
                            },
                            updateInvestmentObjective: function (caseId, clientCase) {
                                return crmApiGateway.put(`/Cases/${caseId}/InvestmentObjective`, clientCase);
                            },
                            updateInvestmentKnowledge: function (caseId, clientCase) {
                                return crmApiGateway.put(`/Cases/${caseId}/InvestmentKnowledge`, clientCase);
                            },
                            updateRiskTolerance: function (caseId, clientCase) {
                                return crmApiGateway.put(`/Cases/${caseId}/RiskTolerance`, clientCase);
                            },
                            createCase: function (clientId, clientCase) {
                                return crmApiGateway.post(`/Clients/${clientId}/Cases`, clientCase);
                            },
                            addPlanningNote: function(caseId, note) {
                                return crmApiGateway.post(`/Cases/${caseId}/PlanningNotes`, note);
                            },
                            deleteCase: function(caseId) {
                                return crmApiGateway.delete(`/Cases/${caseId}`);
                            },
                            deletePlanningNote: function (caseId, noteId) {
                                return crmApiGateway.delete(`/Cases/${caseId}/PlanningNotes` + noteId);
                            },
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line